import { Agreement, ROLE } from '@/shared/api/borrow';

export const findAgreement = (agreements: Agreement[], role: ROLE, address: string) => {
    return agreements.find((agr) => agr.role === role && agr.address === address);
};
